export const DISPLAY_NOTIFICATION = 'DISPLAY_NOTIFICATION';
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';
export const NOTIFICATION_SUCCESS = 'NOTIFICATION_SUCCESS';
export const NOTIFICATION_WARNING = 'NOTIFICATION_WARNING';
export const NOTIFICATION_ERROR = 'NOTIFICATION_ERROR';
export const SHOW_GLOBAL_NOTIFICATION = 'SHOW_GLOBAL_NOTIFICATION';
export const HIDE_GLOBAL_NOTIFICATION = 'HIDE_GLOBAL_NOTIFICATION';

export const INCREMENT_PENDING_REQUESTS = 'INCREMENT_PENDING_REQUESTS';
export const DECREMENT_PENDING_REQUESTS = 'DECREMENT_PENDING_REQUESTS';
export const SUCCESS_AXIOS_CALL = 'SUCCESS_AXIOS_CALL';
export const FAILED_AXIOS_CALL = 'FAILED_AXIOS_CALL';
export const RESET_AXIOS_CALL = 'RESET_AXIOS_CALL';

export const USER_LOCALE = 'USER_LOCALE';

/**
* Register user
*/
export const REQUEST_VERIFICATION_USER = 'REQUEST_VERIFICATION_USER';
export const REQUEST_NEW_VERIFICATION_USER = 'REQUEST_NEW_VERIFICATION_USER';
export const EMAIL_VERIFICATION_SUCCESS = 'EMAIL_VERIFICATION_SUCCESS';
export const EMAIL_VERIFICATION_RESEND = 'EMAIL_VERIFICATION_RESEND';
export const REQUEST_ACTIVATE_ACCOUNT = 'REQUEST_ACTIVATE_ACCOUNT';

/**
 * Login action types
 */
export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const TOKEN_DETAILS = 'TOKEN_DETAILS';
export const USER_DETAILS = 'USER_DETAILS';
export const USER_INFO_LOADING = 'USER_INFO_LOADING';
export const USER_INFO = 'USER_INFO';
export const USER_LOGOUT = 'USER_LOGOUT';
export const REQUEST_VERIFY = 'REQUEST_VERIFY';
export const REQUEST_LOGIN_PASSKEY = 'REQUEST_LOGIN_PASSKEY';
/**
 * Forgot password action types
 */
export const REQUEST_FORGOT = 'REQUEST_FORGOT';
export const REQUEST_NEW_PASSWORD_FORGOT = 'REQUEST_NEW_PASSWORD_FORGOT';

/**
 * Modal toggle
 */
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const RESET_MODAL = 'RESET_MODAL';

/**
 * Cookie Modal
 */
export const STORE_COOKIE_DATE= 'Store_COOKIE_DATA';

/**
 * Profile
 */
export const UPDATE_PROFILE= 'UPDATE_PROFILE';

/**
 * Tables searches
 */
export const TABLES_SEARCHES = 'TABLES_SEARCHES';
export const RESET_TABLES_SEARCHES = 'RESET_TABLES_SEARCHES';

export const PUSH_NOTIFICATIONS_SUBSCRIBE = 'PUSH_NOTIFICATIONS_SUBSCRIBE';
export const PUSH_NOTIFICATIONS_UNSUBSCRIBE = 'PUSH_NOTIFICATIONS_UNSUBSCRIBE';
